import React, { useEffect, useState } from "react";
import { ViewButton } from "../../../../../components/mui/Buttons/Buttons";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Loader3D from "../../../../../components/Loader/Loader3D";
import AddOrEditCheckList from "./AddOrEditCheckList";
import LinkOpenTab from "./LinkOpenTab";
import { useDispatch } from "react-redux";
import { getEvaluationTracker } from "../../../../../redux/features/CRDslice";
import { useSelector } from "react-redux";
import DeleteEvaluationTrack from "./DeleteEvaluationTrack";

const EvaluationTrackerLanding = ({ admissionNo, name }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { loading, evaluationTracker } = useSelector((store) => store.crd);
  const handleCancel = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      dispatch(getEvaluationTracker(admissionNo));
    }
  }, [open]);
  return (
    <GlobalDialog
      maxWidth={"md"}
      fullWidth
      title={
        <>
          {/* Evaluation Tracker{" "} */}
          <span style={{ color: "#1eafe4", fontWeight: "bold" }}>{name}</span>
          {" ("}
          <span style={{ color: "#845092", fontWeight: "bold" }}>
            {admissionNo}
          </span>
          {")"}
        </>
      }
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <ViewButton action={() => setOpen(true)}>View</ViewButton>
        </>
      }
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <Box>
                <TableContainer>
                  <Table sx={{ minWidth: 650, borderCollapse: "collapse" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{
                            border: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          Pro Valuation 
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            border: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          Evaluation
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            border: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          Impact Report
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{
                            border: "1px solid #ccc",
                            fontWeight: "bold",
                          }}
                        >
                          Other
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell  sx={{ border: "1px solid #ccc" }}>
                          <Stack direction={"column"} gap={1}>
                            <AddOrEditCheckList
                              admissionNo={admissionNo}
                              checkedTrue={
                                evaluationTracker?.evaluation1_status
                              }
                              link={evaluationTracker?.evaluation1_link}
                              id={evaluationTracker?.evaluation1_id}
                              labelName={"Evaluation-1 Done"}
                            />
                            <LinkOpenTab
                              link={evaluationTracker?.evaluation1_link}
                            />
                          </Stack>
                        </TableCell>
                        <TableCell  sx={{ border: "1px solid #ccc" }}>
                          <Stack direction={"column"} gap={1}>
                            <AddOrEditCheckList
                              admissionNo={admissionNo}
                              checkedTrue={
                                evaluationTracker?.evaluation2_status
                              }
                              link={evaluationTracker?.evaluation2_link}
                              id={evaluationTracker?.evaluation2_id}
                              labelName={"Evaluation-2 Done"}
                              isDisable={
                                evaluationTracker?.evaluation1_id ? false : true
                              }
                            />
                            <LinkOpenTab
                              link={evaluationTracker?.evaluation2_link}
                            />
                          </Stack>
                        </TableCell>
                        <TableCell  sx={{ border: "1px solid #ccc" }}>
                          <Stack direction={"column"} gap={1}>
                            <AddOrEditCheckList
                              admissionNo={admissionNo}
                              checkedTrue={
                                evaluationTracker?.evaluation3_status
                              }
                              link={evaluationTracker?.evaluation3_link}
                              id={evaluationTracker?.evaluation3_id}
                              labelName={"Impact Done"}
                              isDisable={
                                evaluationTracker?.evaluation2_id ? false : true
                              }
                            />
                            <LinkOpenTab
                              link={evaluationTracker?.evaluation3_link}
                            />
                          </Stack>
                        </TableCell>
                        <TableCell  sx={{ border: "1px solid #ccc" }}>
                          <Stack direction={"column"} gap={1}>
                            <AddOrEditCheckList
                              admissionNo={admissionNo}
                              otherLinkTrue={true}
                              checkedTrue={
                                evaluationTracker?.other_link ? true : false
                              }
                              link={evaluationTracker?.other_link}
                              id={evaluationTracker?.other_link_id}
                              labelName={"Other Link "}
                            />
                            <Stack
                              direction={"row"}
                              gap={1}
                              sx={{
                                visibility: evaluationTracker?.other_link
                                  ? "visible"
                                  : "hidden",
                              }}
                            >
                              <LinkOpenTab
                                link={evaluationTracker?.other_link}
                              />
                              <DeleteEvaluationTrack
                                admissionNo={admissionNo}
                                id={evaluationTracker?.other_link_id}
                              />
                            </Stack>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          )
        ) : null
      }
    />
  );
};

export default EvaluationTrackerLanding;
